export default {
  name: 'name',
  size: 'size',
  extension: 'extension',
  updated: 'updated'
};